import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats a number with locale-specific thousands separators
 * @param value - The number to format
 * @returns Formatted string with commas (e.g., "1,234")
 */
export function formatNumber(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return "0"
  }
  return value.toLocaleString()
}
